import { ISurveyContract, ISurveyUpdateContract } from "../contracts/Survey";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync, putDataAsync } from "../ZeosApiExecutor";
import { IGetSurveyTemplateOptions, ISurvey } from "./interfaces/ISurvey";

const BASE_URL = `/Survey`;

export const Survey: ISurvey = {
  getSurveyTemplate: async (
    templateId: number,
    options?: IGetSurveyTemplateOptions
  ): Promise<IZeosApiResponse<ISurveyContract>> => {
    const query =
      options?.mode != null
        ? `?mode=${encodeURIComponent(options.mode)}`
        : "";
    return await getDataAsync<ISurveyContract>(
      `${BASE_URL}/Template/${templateId}${query}`,
      ""
    );
  },

  submitSurveyInstance: async (
    payload: ISurveyUpdateContract
  ): Promise<IZeosApiResponse<string>> => {
    return await postDataAsync<string>(`${BASE_URL}/Instance`, payload);
  },

  getUserSurvey: async (
    surveyTemplateId: number,
    zeosUserId: number
  ): Promise<IZeosApiResponse<ISurveyUpdateContract>> => {
    return await getDataAsync<ISurveyUpdateContract>(
      `${BASE_URL}/Instance/${surveyTemplateId}/User/${zeosUserId}`,
      ""
    );
  },

  updateSurveyInstance: async (
    payload: ISurveyUpdateContract
  ): Promise<IZeosApiResponse<boolean>> => {
    return await putDataAsync<boolean>(`${BASE_URL}/Instance`, payload, false);
  },
};
